import { render } from "./offer-card.vue?vue&type=template&id=0a417d27&scoped=true"
import script from "./offer-card.vue?vue&type=script&lang=js"
export * from "./offer-card.vue?vue&type=script&lang=js"

import "./offer-card.vue?vue&type=style&index=0&id=0a417d27&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a417d27"]])

export default __exports__